import SmartAssignmentSelect from './smart_assignment_select';

export default SmartAssignmentSelect;
